import { Fragment, FC, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import PatientApi from "Service/Patient.api";
import { RedoxResultType } from "DataTypes/Services/Patient.type";
import Loader from "Components/Loader";
import NoData from "Components/NoData";
import { SideModalProps } from "DataTypes/Modal";
import { PatientInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import RedoxFormatter from "Utils/Redox.Formatter";
import UpdateResult from "./UpdateResult";
import { CommonStyle } from "Components";
import ImgPath from "Constant/Imgs";

export interface DataActionType {
  data: RedoxResultType | null;
  action: "ADD" | "EDIT" | "VIEW" | null;
}

const Result: FC<SideModalProps> = (props) => {
  const { onClose } = props;
  const { patientInfo }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const [resultData, setResultData] = useState<RedoxResultType[]>([]);
  const [loading, setLoading] = useState(true);
  const [dataAction, setDataAction] =
    useState<DataActionType>({ data: null, action: null });

  useEffect(() => {
    fetchResults();
  }, []);

  const fetchResults: () => void = async () => {
    const res: any = await PatientApi.RedoxResults({ id1: patientInfo.id });
    if (res?.success) {
      setResultData(RedoxFormatter.ResultList(res?.data?.results));
    }
    setLoading(false);
  };

  const handleCloseLayer2: () => void = () => {
    setDataAction({ data: null, action: null })
  };

  const Layer1Header = (
    <Box sx={{ ...sxHeader, ...CommonStyle.sxRow }}>
      <Typography fontWeight="bold">Results</Typography>
      <Box display={"flex"}>
        {/* <Box
          sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
          onClick={() => setDataAction({ data: null, action: "ADD" })}
        >
          <ImgPath.PlusIcon titleAccess="Add Result" />
        </Box> */}
        <Box
          sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
          onClick={() => {
            handleCloseLayer2();
            onClose();
          }}
        >
          <ImgPath.CloseIcon titleAccess="Close" />
        </Box>
      </Box>
    </Box>
  );

  const Layer1List = (
    resultData.map((el) => {
      return (
        <Typography key={el.id} variant="body2" sx={{ mb: 1 }}>
          • {el.resultName} - {el.observationName}
          {el.observationValue
            ? " - "
            + el.observationValue +
            (
              el.observationUnit ?
                " " + el.observationUnit : ""
            ) : ""
          }
        </Typography>
      );
    })
  );

  const Layer1 = (
    <Fragment>
      {Layer1Header}
      <Box sx={{ ...sxMain }}>
        {loading ? <Loader /> : resultData.length ? Layer1List : <NoData />}
      </Box>
    </Fragment>
  );

  return (
    <Fragment>
      <Box width="25%">{Layer1}</Box>
      <Box width="1%"></Box>
      {dataAction.action && (
        <Box width="64%">
          <UpdateResult
            dataAction={dataAction}
            onClose={handleCloseLayer2}
            refreshList={fetchResults}
          />
        </Box>
      )}
    </Fragment>
  );
};

export default Result;

const sxHeader = {
  justifyContent: "space-between",
  height: "10%",
  px: 2,
};

const sxMain = {
  height: "90%",
  overflow: "auto",
  px: 2,
};
